"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarHeader = void 0;
var _styledComponents = require("styled-components");
var CalendarDayNames = (0, _styledComponents.css)([".react-datepicker__day-names{order:0;display:flex;justify-content:", ";margin-bottom:17px;margin-top:15px;.react-datepicker__day-name{", " ", " text-transform:uppercase;font-size:12px;line-height:13px;color:", ";&:nth-child(6),&:nth-child(7){color:", ";opacity:0.4;}}}"], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? 'center' : 'space-evenly';
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile && 'width: 44px;';
}, function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile && 'margin: 0;';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.frenchGray;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.monza;
});
var CalendarHeader = exports.CalendarHeader = (0, _styledComponents.css)([".react-datepicker__header{text-transform:capitalize;display:flex;flex-direction:column;border-radius:0;padding:0;padding-bottom:8px;border-bottom:0;background-color:#fff;}.react-datepicker__current-month{order:2;font-size:18px;line-height:22px;color:", ";}", ""], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.blackBase;
}, CalendarDayNames);